import {
  DynamicField,
  DynamicForm,
  FieldVariant,
  SelectFieldProps,
  SelectOption,
  TextFieldProps,
} from '../../../../components/form-builder/form-builder.types';
import { AddressRepository } from '../../../../store/address-state/address-state.repository';

interface getAddressFormObjectProps {
  store: AddressRepository;
  addressTypesOptions?: SelectOption[];
}

export const getAddressFormObject = ({ store, addressTypesOptions }: getAddressFormObjectProps): DynamicForm => {
  const addressColumn: DynamicField<TextFieldProps> = {
    label: 'settings.address.form.address.label',
    variant: FieldVariant.TEXT,
    isRequired: true,
    props: {
      value: store.getNestedObservable<string>('dto', 'address'),
      onChange: (value: string) => store.setNested('dto', 'address', value),
    },
  };
  const typeColumn: DynamicField<SelectFieldProps> = {
    label: 'settings.address.form.type.label',
    variant: FieldVariant.SELECT,
    isRequired: true,
    props: {
      placeholder: 'settings.address.form.type.placeholder',
      options: addressTypesOptions,
      value: store.getObservable<SelectOption>('addressTypeSelected'),
      onSelectChange: (value: SelectOption) => {
        store.setNested('dto', 'typeId', value.code);
        store.setNested('addressTypeSelected', value);
      },
    },
  };
  return {
    title: 'Address Form',
    isHeaderHidden: true,
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [addressColumn],
          },
          {
            fields: [typeColumn],
          },
        ],
      },
    ],
  };
};
